import React from "react";
import { CircleCheckBig } from "lucide-react";

const ThankYou = () => {
	return (
		<div className="flex justify-center">
			<div className="bg-white rounded-xl border border-[#EEEEEE] m-4 p-4 px-8 w-[full]">
				<div className="flex flex-col items-center justify-center w-full">
					<CircleCheckBig className="text-green-500" size={48} />
					<div className="text-center mt-3 px-4">
						<h3 className="text-xl font-medium">Thank you!</h3>
						<p>
							We've saved your responses. You may close this
							window.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ThankYou;
